"use strict";

function _typeof(e) {
	return (_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
		return typeof e
	} : function(e) {
		return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
	})(e)
}

function _slicedToArray(e, t) {
	return _arrayWithHoles(e) || _iterableToArrayLimit(e, t) || _unsupportedIterableToArray(e, t) || _nonIterableRest()
}

function _nonIterableRest() {
	throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
}

function _unsupportedIterableToArray(e, t) {
	if (e) {
		if ("string" == typeof e) return _arrayLikeToArray(e, t);
		var r = Object.prototype.toString.call(e).slice(8, -1);
		return "Object" === r && e.constructor && (r = e.constructor.name), "Map" === r || "Set" === r ? Array.from(e) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? _arrayLikeToArray(e, t) : void 0
	}
}

function _arrayLikeToArray(e, t) {
	(null == t || t > e.length) && (t = e.length);
	for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
	return n
}

function _iterableToArrayLimit(e, t) {
	if ("undefined" != typeof Symbol && Symbol.iterator in Object(e)) {
		var r = [],
			n = !0,
			i = !1,
			a = void 0;
		try {
			for (var o, l = e[Symbol.iterator](); !(n = (o = l.next()).done) && (r.push(o.value), !t || r.length !== t); n = !0);
		} catch (e) {
			i = !0, a = e
		} finally {
			try {
				n || null == l.return || l.return()
			} finally {
				if (i) throw a
			}
		}
		return r
	}
}

function _arrayWithHoles(e) {
	if (Array.isArray(e)) return e
}
var tenant_id = false;
var widgetCurrency = "";
var initScript = function() {
	var c = {
		getTemplate: function(e) {
			tenant_id = (e.x_tenant_id)? e.x_tenant_id : false;
			widgetCurrency = (e.body.currencySymbol)?e.body.currencySymbol+" ": "";
			switch (e.body.currency_symbol && (CURRENCY_SYMBOL = e.body.currency_symbol), e.widgetType) {
				case "summary":
					bankStatementSummeryScript.main(e);
					break;
				case "yodlee":
					yodleeAutoManualScript.main(e);
					break;
				case "analysis":
					BankStatementAnalysis.main(e);
					break;
				case "yodlee_manual":
					yodleeManualScript.main(e);
					break;
				case "yodlee_pdf":
					yodleePDFGenerator.main(e);
					break;
				case 'yodlee_auto':
				yodleeAutoScript.main(e);
					break;
				case 'finbit_manual':
					finbitManualScript.main(e);
					break;
				case "summary-v2":
					return c.returnPromise(e);
				case "summary-v2pdf":
					return analyserV2pdf.main(e);
				case "fincity_auto":
					finicityAutoScript.main(e);
					break;
				default:
					alert("Unsupported Widget Type")
			}
		},
		returnPromise: function(e) {
			return analyserV2.main(e)
		},
		getStyleString: function(e) {
			if (e && Object.keys(e).length) return Object.entries(e).reduce(function(e, t) {
				var r = _slicedToArray(t, 2);
				return e + r[0] + ":" + r[1] + ";"
			}, "")
		},
		innerHTMLToATarget: function(e, t) {
			c.getHTMLElementObject(e).html(t)
		},
		appendHTMLToATarget: function(e, t) {
			c.getHTMLElementObject(e).append(t)
		},
		toggleLoader: function() {
			var e = !(0 < arguments.length && void 0 !== arguments[0]) || arguments[0];
			!(1 < arguments.length && void 0 !== arguments[1] && arguments[1]) && e ? c.getHTMLElementObject("body").addClass("yodleeContainerWrapper") : c.getHTMLElementObject("body").removeClass("yodleeContainerWrapper"), c.getHTMLElementByDelimiter("widgetLoaderWrapper").css("display", e ? "block" : "none")
		},
		disableElementByProp: function(e) {
			var t = !(1 < arguments.length && void 0 !== arguments[1]) || arguments[1];
			c.getHTMLElementObject(e).prop("disabled", t)
		},
		appendCSS: function(e) {
			if (e.hasOwnProperty("css"))
				for (var t = Object.keys(e.css), r = 0; r < t.length; ++r) c.getHTMLElementByDelimiter(t[r]).attr("style", c.getStyleString(e.css[t[r]]))
		},
		duplicateEmptyRowsInTableIdentifier: function(e, t, r) {
			if (!e.addNewTransactionFlag) return !0;
			if (t.length && !(t[0].children.length < 2 || t[0].children[1].children.length < r)) {
				var n = c.removeUnexpectedElements(Object.keys(e.dp[0][0]), ["index", "id", "_id"]);
				if (t[0].children[1].children.length && t[0].children[1].children[0].children.length) {
					for (var i = t[0].children[1].children[r].children, a = 0; a < i.length; ++a)
						if ("date" !== n[a] && "type" !== n[a] && i[a].textContent.toString().trim().length) return !0;
					return !1
				}
			}
		},
		isEmptyRow: function(e, t, r) {
			for (var n = e.classNames.tbody + "_" + t + "_tr_" + r, i = c.getHTMLElementByDelimiter(n).children(), a = 0; a < e.original.headers.length; ++a)
				if (i[a].textContent.toString().trim().length) return !1;
			return !0
		},
		bindAttrsOnHTMLTag: function(e, t) {
			for (var r = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : {}, n = "<" + e + " ", i = "", a = Object.keys(r), o = 0; r.nbsp && o < r.nbsp; ++o) i += "&nbsp;";
			for (var l = 0; l < a.length; ++l) {
				var u = a[l].toString().trim().toLowerCase();
				n += "style" === u || "css" === u ? 'style="' + c.getStyleString(r[a[l]]) + '" ' : a[l] + '="' + r[a[l]] + '" '
			}
			return n += ">" + t + "</" + e + ">" + i
		},
		getDateFormationType: function(e) {
			for (var t = 0; t < e.length; ++t)
				if (e[t] < "a" || "z" < e[t]) return e[t]
		},
		dateFormat: function(e, t) {
			if (2 !== t.length) return e;
			var r = c.getDateFormationType(t[0]) || "/",
				n = c.getDateFormationType(t[1]) || "/",
				i = t[0].split(r),
				a = t[1].split(n);
			e = e.split(r);
			var o = {};
			return o[i[0]] = e[0], o[i[1]] = e[1], o[i[2]] = e[2], o[a[0]] + n + o[a[1]] + n + o[a[2]]
		},
		getCurrentDate: function() {
			var e = new Date;
			return e.getDate() + "/" + (e.getMonth() + 1) + "/" + e.getFullYear()
		},
		getMonthDayYearFormatDate: function(e) {
			if ("string" != typeof e) return e;
			var t = e.split("/");
			return t.length < 3 ? e : t[1] + "/" + t[0] + "/" + t[2]
		},
		attachIcons: function(e, t, r, n) {
			for (var i = "", a = 0; a < t.length; ++a) i += e.icons_src[t[a] + "IconHTML"]({
				class: BankStatementAnalysis.getICONClass(r, n, t[a])
			});
			return i
		},
		changeIcons: function(e, t, r, n, i) {
			c.changeHTMLOfAClass(i, c.attachIcons(e, t, r, n))
		},
		changeHTMLOfAClass: function(e, t) {
			c.getHTMLElementByDelimiter(e).html(t)
		},
		getHTMLElementByDelimiter: function(e) {
			var t = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : ".";
			return "object" === _typeof(e) ? c.getHTMLElementObject(e) : c.getHTMLElementObject(t + e)
		},
		getHTMLElementByDomClass: function(e) {
			return document.getElementsByClassName(e)
		},
		getHTMLElementByDomId: function(e) {
			return document.getElementById(e)
		},
		getHTMLElementByDom: function(e) {
			var t = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : void 0;
			return "object" === _typeof(e) ? c.getHTMLElementObject(e) : void 0 === t || "." === t ? c.getHTMLElementByDomClass(e) : c.getHTMLElementByDomId(e)
		},
		getHTMLElementObject: function(e) {
			return $(e)
		},
		removeHtmlElement: function(e) {
			var t = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : ".";
			return c.getHTMLElementByDelimiter(e, t).remove()
		},
		removeHtmlProperty: function(e) {
			return c.getHTMLElementByDom(e).remove()
		},
		addCSSAtTargetIdentifier: function(e, t) {
			var r = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : ".";
			return c.getHTMLElementByDelimiter(e, r).attr("style", c.getStyleString(t))
		},
		getHtmlElementClass: function(e) {
			return c.getHTMLElementObject(e).attr("class")
		},
		generateQueryParams: function(e) {
			for (var t = "", r = Object.keys(e), n = 0; n < r.length; ++n) t += (0 < n ? "&" : "") + r[n] + "=" + e[r[n]];
			return t
		},
		_base64ToArrayBuffer: function(e) {
			for (var t = atob(e), r = new Uint8Array(t.length), n = 0; n < t.length; n++) r[n] = t.charCodeAt(n);
			return r
		},
		urlToFile: function(e, t, r) {
			return WidgetNativeRequest(e).then(function(e) {
				return e.arrayBuffer()
			}).then(function(e) {
				return new File([e], t, {
					type: r
				})
			})
		},
		hasObjectKeyPropertyUtil: function(e, t, r) {
			if (e.hasOwnProperty(t.key)) return !0;
			if (0 === r) return !1;
			for (var n = Object.keys(e), i = !1, a = 0; a < n.length; ++a) i = i || ("object" === _typeof(e[n[a]]) ? c.hasObjectKeyPropertyUtil(e[n[a]], t, r - 1) : i);
			return i
		},
		hasObjectKeyProperty: function(e, t) {
			"string" == typeof t && (t = {
				key: t
			});
			var r = t.hasOwnProperty("maxLevel") ? t.maxLevel : 10;
			return c.hasObjectKeyPropertyUtil(e, t, r)
		},
		separateNumberByDelimiter: function(e) {
			var t = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : [3, ","],
				r = !(2 < arguments.length && void 0 !== arguments[2]) || arguments[2];
			if (!isNaN(e)) {
				var n = e.toString().split(".");
				return e = Number(e), 2 === n.length && (e = c.toFixedMiddleware(+e + 1e-4)), e = e.toString().replace(new RegExp("\\B(?=(\\d{" + t[0] + "})+(?!\\d))", "g"), t[1]), (r ? c.updateStringNumberSign(e) : e) + (r ? "K" : "")
			}
		},
		separateNumberWithoutDelimiter: function(e) {
			var t = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : 3;
			return c.toFixedMiddleware((+e + 1 / Math.pow(10, t + 1)) / Math.pow(10, t))
		},
		separateNumberByComma: function(e) {
			var t = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : [3, ","],
				r = !(2 < arguments.length && void 0 !== arguments[2]) || arguments[2];
			if (!isNaN(e)) {
				var n = e.toString().split(".");
				return e = Number(e), 2 === n.length && (e = c.toFixedMiddleware(+e + 1e-4)), e = e.toString().replace(new RegExp("\\B(?=(\\d{" + t[0] + "})+(?!\\d))", "g"), t[1]), (e)
			}
		},
		separateNumberByCommaFixedTo2Decimal: function(e) {
			var t = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : [3, ","],
				r = !(2 < arguments.length && void 0 !== arguments[2]) || arguments[2];
			if (!isNaN(e)) {
				e = e.toFixed(2)
				var n = e.toString().split(".");
				return e = Number(e), 2 === n.length && (e = c.toFixedMiddleware(+e + 1e-4)), e = e.toString().replace(new RegExp("\\B(?=(\\d{" + t[0] + "})+(?!\\d))", "g"), t[1]), (e)
			}
		},
		separateNumberByCommaFixedTo2DecimalwithSign: function(e) {
			var t = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : [3, ","],
				r = !(2 < arguments.length && void 0 !== arguments[2]) || arguments[2];
			if (!isNaN(e)) {
				e = e.toFixed(2)
				var n = e.toString().split(".");
				e = Number(e), 2 === n.length && (e = c.toFixedMiddleware(+e + 1e-4)), e = e.toString().replace(new RegExp("\\B(?=(\\d{" + t[0] + "})+(?!\\d))", "g"), t[1]), (e)
				return widgetCurrency+e;
			}
		},
		separateNumberByCommaAndRoundOff: function(e) {
			var t = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : [3, ","],
				r = !(2 < arguments.length && void 0 !== arguments[2]) || arguments[2];
			if (!isNaN(e)) {
				e = c.roundOff(e)
				var n = e.toString().split(".");
				return e = Number(e), 2 === n.length && (e = c.toFixedMiddleware(+e + 1e-4)), e = e.toString().replace(new RegExp("\\B(?=(\\d{" + t[0] + "})+(?!\\d))", "g"), t[1]), (e)
			}
			else{
				return e;
			}
		},
		separateNumberByCommaAndRoundOffwithSign: function(e) {
			var t = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : [3, ","],
				r = !(2 < arguments.length && void 0 !== arguments[2]) || arguments[2];
			if (!isNaN(e)) {
				e = c.roundOff(e)
				var n = e.toString().split(".");
				e = Number(e), 2 === n.length && (e = c.toFixedMiddleware(+e + 1e-4)), e = e.toString().replace(new RegExp("\\B(?=(\\d{" + t[0] + "})+(?!\\d))", "g"), t[1]), (e)
				return widgetCurrency+e;
			}
			else{
				return e;
			}
		},
		toFixedMiddleware: function(e) {
			var t = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : 2;
			return 0 === e ? e : e.toFixed(t)
		},
		updateStringNumberSign: function(e) {
			return "-" === e[0] ? e.replaceAt(0, "-" + CURRENCY_SYMBOL) : CURRENCY_SYMBOL + e
		},
		separateNumberByDelimiterWithSign: function(e) {
			var t = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : [3, ","];
			if (isNaN(e)) return e;
			var r = c.separateNumberByDelimiter(e, t).toString().replace(/[$]/gm, "");
			return c.updateStringNumberSign(r)
		},
		separateNumberByDelimiterWithSignAndThousand: function(e) {
			var t = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : [3, ","];
			if (isNaN(e)) return e;
			var r = c.separateNumberByDelimiter(e / 1e3, t, !1).toString();
			return ("-" === r[0] ? r.replaceAt(0, "-" + CURRENCY_SYMBOL) : CURRENCY_SYMBOL + r) + "K"
		},
		separateNumberByDelimiterWithoutSign: function(e) {
			return isNaN(e) ? e : c.separateNumberByDelimiter(e / 1e3, [3, ","], !1)
		},
		roundOffWithThousand: function(e) {
			var t = !(1 < arguments.length && void 0 !== arguments[1]) || arguments[1];
			if (isNaN(e)) return e;
			var r = c.roundOff(+c.separateNumberWithoutDelimiter(e)).toString();
			return t ? c.separateNumberByDelimiterWithSignAndThousand(r) : r
		},
		currencyAmount: function(e) {
			return ("-" === (e = e.toString())[0] ? e.replaceAt(0, "-" + CURRENCY_SYMBOL) : CURRENCY_SYMBOL + e) + "K"
		},
		separateNumberByDelimiterMiddleware: function(e) {
			var t = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : void 0,
				r = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : [3, ","],
				n = c.separateNumberByDelimiter(e, r);
			return t ? c[t] ? c[t](n) : templateEvents[t](n) : n
		},
		convertStringToNumber: function(e) {
			return e.replace(/[,$]/gm, "")
		},
		keyToCamelCaseString: function(e) {
			var t = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : "";
			return e.replace(/[_][a-z]/gm, function(e) {
				return e[1].toUpperCase()
			}) + t
		},
		keyToCamelCaseWithUpperCaseString: function(e) {
			var t = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : "";
			return (e = c.keyToCamelCaseString(e, t)).length ? e.replace(e[0], e[0].toUpperCase()) : e
		},
		removeTargetIdentifierChildren: function(e) {
			for (var t = e.lastElementChild; t;) e.removeChild(t), t = e.lastElementChild
		},
		getTargetIdentifierText: function(e) {
			var t = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : ".";
			return c.getHTMLElementByDelimiter(e, t).text()
		},
		roundOff: function(e) {
			var t = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : void 0;
			if (e = Array.isArray(e) && e.length ? e[0] : e, isNaN(e)) return e;
			var r = Math.round(e + 1e-4);
			return t ? c[t] ? c[t](r) : templateEvents[t](r) : r
		},
		atoi: function(e) {
			var t = "0".charCodeAt(0),
				r = 1;
			"-" === e[0] && (e = e.substring(1), r = -1);
			var n = 0,
				i = !0,
				a = !1,
				o = void 0;
			try {
				for (var l, u = e[Symbol.iterator](); !(i = (l = u.next()).done); i = !0) n = 10 * n + (l.value.charCodeAt(0) - t)
			} catch (e) {
				a = !0, o = e
			} finally {
				try {
					i || null == _iterator.return || _iterator.return()
				} finally {
					if (a) throw o
				}
			}
			return r * n
		},
		encryptAccountNumber: function(e) {
			var n = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : "x";
			return e.replace(/(\d+)(\d{4})/g, function(e, t, r) {
				return c.repeatStr(n, t.length) + r
			})
		},
		encryptEmail: function(e) {
			var t = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : "x";
			return e ? (e = Array.isArray(e) ? e[0] : e).substr(0, Math.min(e.length, 4)) + c.repeatStr(t, 8) : e
		},
		isObjectEqual: function(e, t) {
			var r = Object.keys(e),
				n = Object.keys(t);
			if ("string" == typeof e && e !== t) return !1;
			if ("string" == typeof e) return !0;
			if (r.length !== n.length) return !1;
			for (var i = !1, a = 0; a < r.length; ++a) {
				if (!t.hasOwnProperty(r[a]) || !e.hasOwnProperty(n[a])) return !1;
				i = c.isObjectEqual(e[r[a]], t[r[a]])
			}
			return i
		},
		methodWiseOption: function(e) {
			var t = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {},
				r = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : {};
			t.type = e || t.type;
			var n = Object.keys(r);
			t.headers || (t.headers = {});
			for (var i = 0; i < n.length; ++i) {
				var a = n[i];
				t[a] = t[a] ? t[a] : {}, Object.assign(t[a], r[a])
			}
			return t
		},
		setPropertyOnTargetElement: function(e, t, r) {
			var n = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : ".";
			return c.getHTMLElementByDelimiter(e, n).prop(t, r)
		},
		gcd: function(e, t) {
			return 0 === e ? t : gcd(t % e, e)
		},
		reverseArray: function(e, t, r) {
			for (; t < r;) {
				var n = e[t];
				e[t] = e[r], e[r] = n, t++, r--
			}
			return e
		},
		leftRotate: function(e, t) {
			for (var r = e.length, n = gcd(t, r), i = 0; i < n; i++) {
				for (var a = e[i], o = i;;) {
					var l = o + t;
					if (r <= l && (l -= r), l === i) break;
					e[o] = e[l], o = l
				}
				e[o] = a
			}
			return e
		},
		compareTwoObject: function(e, t) {
			var r = Object.getOwnPropertyNames(e),
				n = Object.getOwnPropertyNames(t);
			if (r.length !== n.length) return !1;
			for (var i = 0; i < r.length; i++)
				if (e[r[i]] !== t[r[i]]) return !1;
			return !0
		},
		hashCode: function(e) {
			var t = 0;
			if (0 === e.length) return t;
			for (var r = 0; r < e.length; r++) t = e.charCodeAt(r) + "" + t;
			return t
		},
		objectHashCode: function(e) {
			for (var t = Object.getOwnPropertyNames(e), r = 0, n = 0; n < t.length; ++n) r += Number(c.hashCode(t[n].toString()) + c.hashCode(e[t[n]].toString()));
			return r
		},
		mod: function(e) {
			var t = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : 1e9 + 7;
			return (e % t + t) % t
		},
		power: function(e, t) {
			for (var r = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null, n = 1; t;) r && 1 & t ? n = n * e % r : 1 & t && (n *= e), t >>= 1, e *= e, r && (e %= r);
			return n
		},
		repeatStr: function(e, t) {
			for (var r = e; 1 < t--;) e += r;
			return e
		},
		getTargetIdentifierElement: function(e) {
			var t = e;
			if ((e = e.toString().trim()).length) {
				var r = e[0];
				switch (e = e.substr(1, e.length), r) {
					case ".":
						return document.getElementsByName(e);
					case "#":
						return document.getElementById(e);
					default:
						return document.getElementsByTagName(t)
				}
			}
		},
		isValidJson: function(e) {
			if (!e || !e.length) return !1;
			for (var t = new Stack, r = 0; r < e.length; ++r) {
				var n = e.charAt(r);
				if ("{" === n) t.push(n);
				else if ("}" === n) {
					if (!t.size() || "{" !== t.storage[t.size() - 1]) return !1;
					t.pop()
				}
			}
			return !t.size()
		},
		validateBraces: function(e) {
			for (var t = "";;) {
				var r = e.pop();
				if (r.equals("{")) return 2 === t.split(":").length;
				t += r
			}
			return !1
		},
		validateComma: function(e) {
			for (var t = "", r = !0; r;) {
				var n = e.pop();
				if (n.equals("{")) return r = !1, e.push("{"), 2 === t.split(":").length;
				t += n
			}
			return !1
		},
		wrapOnTargetIdentifierElement: function(e, t) {
			c.getHTMLElementObject(e).contents().wrap(t)
		},
		unWrapOnTargetIdentifierElement: function(e) {
			c.getHTMLElementObject(e).contents().unwrap()
		},
		getAdjacentList: function(e) {
			for (var t = [], r = 1; r <= MAXN; ++r) t[r] = [];
			var n = Object.keys(e);
			if (!n) return t;
			for (var i = 0; i < n.length; ++i) "tree_size" !== n[i] && "1" !== n[i] && e[n[i]].parent && t[e[n[i]].parent].push(Number(n[i]));
			return t
		},
		getSRCUrl: function(e) {
			var t = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {};
			return e && e.match(/{[ \w\d\[\].]*}/gm) ? c.compileHTML(e, t) : e
		},
		jsonToHtmlConfig: function(e) {
			for (var t = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {}, r = "", n = Object.keys(e), i = 0; i < n.length; ++i) {
				var a = n[i].toString().trim().toLowerCase();
				r += "style" === a || "css" === a ? 'style="' + c.getStyleString(e[n[i]]) + (i + 1 === n.length ? '" '.trim() : '" ') : n[i] + '="' + ("src" === a ? t.img_src + templateEvents.getCDNIcon(c.getSRCUrl(e.src, t), t) : e[n[i]]) + (i + 1 === n.length ? '" '.trim() : '" ')
			}
			return r
		},
		getObjectValueByStringUtil: function(e, t) {
			if (!e) return null;
			for (var r = t.replace(/\[(\w+)\]/g, ".$1").replace(/^\./, "").split("."), n = 0, i = r.length; n < i; ++n) {
				if (void 0 === e[r[n]] && null === e[r[n]]) return;
				e = e[r[n]]
			}
			return e
		},
		getObjectValueByString: function(e, t) {
			if (t && e) {
				if (1 < t.length && "callback" === t[0]) {
					for (var r = void 0, n = t[1], i = [], a = 2; a < t.length; ++a) e.hasOwnProperty(t[a]) ? i.push(c.getObjectValueByStringUtil(e, t[a])) : r = t[a];
					return e.bank_name && "stringMasking" === n && "Paypal Bank" === e.bank_name && (n = "encryptEmail"), templateEvents[n] ? templateEvents[n](i, r) : c[n](i, r)
				}
				return c.getObjectValueByStringUtil(e, t[0])
			}
		},
		compileHTML: function(e, t) {
			for (var r = e.match(/{[ \w\d\[\].]*}/gm) || [], n = [], i = 0; i < r.length; ++i) n.push(r[i]), r[i] = r[i].replace(/[\{\}]/gm, "").trim().split(/ /).filter(function(e) {
				return e
			});
			for (var a = 0; a < r.length; ++a) e = e.replace(n[a], c.getObjectValueByString(t, r[a]));
			return e
		},
		jsonToHTMLUtil: function(e, t, r) {
			var n = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : {},
				i = "";
			i += "<" + t[r].tag + (t[r].config ? " " + c.jsonToHtmlConfig(t[r].config, n) : "") + ">" + (t[r].html ? c.compileHTML(t[r].html, n) : "");
			for (var a = 0; a < e[r].length; ++a) i += c.jsonToHTMLUtil(e, t, e[r][a], n);
			return i += "</" + t[r].tag + ">"
		},
		jsonToHTML: function(e) {
			var t = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {};
			return c.jsonToHTMLUtil(c.getAdjacentList(e), e, 1, t)
		},
		getTableHeadersByConfigWithOrder: function(e) {
			for (var t = [], r = Object.keys(e), n = 0; n < r.length; ++n) t.push({
				name: r[n],
				priority: e[r[n]].order ? e[r[n]].order : Number.MAX_VALUE
			});
			t.sort(function(e, t) {
				return e.priority - t.priority
			});
			for (var i = [], a = 0; a < t.length; ++a) i.push(t[a].name);
			return i
		},
		removeUnderscoreWithCamelCase: function(e) {
			return e.charAt(0).toUpperCase() + e.slice(1).replace(/([-_][a-z])/gi, function(e) {
				return e.toUpperCase().replace("_", " ")
			})
		},
		removeUnexpectedElements: function(e, t) {
			if (!Array.isArray(e) || !Array.isArray(t)) return e;
			for (var r = [], n = 0; n < e.length; ++n) {
				for (var i = !1, a = 0; a < t.length; ++a) e[n] === t[a] && (i = !0);
				i || r.push(e[n])
			}
			return r
		},
		getObjectValue: function(e, t) {
			if (!e) return null;
			for (var r = t.replace(/\[(\w+)\]/g, ".$1").replace(/^\./, "").split("."), n = 0; n < r.length; ++n) {
				if (void 0 === e[r[n]]) return;
				e = e[r[n]]
			}
			return e
		},
		getCommonHTML: function(e) {
			var t = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : "div";
			e = Array.isArray(e) ? e : [e];
			for (var r = "", n = 0; n < e.length; ++n) r += c.bindAttrsOnHTMLTag(t, e[n].html, e[n].config || {});
			return r
		},
		compileJSONWithHTML: function(e, t) {
			var r = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : {};
			t && c.getHTMLElementByDelimiter(t).html(c.jsonToHTML(e, r))
		},
		extractMapData: function(e, t) {
			return e && t ? e.map(function(e) {
				return e[t]
			}) : []
		},
		filterKeyData: function(e, t, r) {
			return e && t && r ? e.filter(function(e) {
				return e[t] === r
			}) : []
		},
		uniqueData: function(e) {
			if (e) {
				for (var t = new Map, r = 0; r < e.length; ++r) t.set(e[r], 1);
				return Array.from(t.keys())
			}
		},
		formatedNumberToValidNumber: function(e, t) {
			return e = Array.isArray(e) ? e[0] : e, Number(e.toString().replace(t ? new RegExp(t) : /[,$a-zA-Z]/gm, ""))
		},
		Array2D: function(e, t) {
			for (var r = new Array(e), n = 0; n < e; ++n) r[n] = new Array(t);
			return r
		},
		strToWords: function(e) {
			for (var t = e.match(/[\w\d\’\'-]+/gi), r = [], n = 0, i = 0; i < t.length; ++i) n = Math.max(n, t[i].length), r.push(t[i].length);
			return {
				array: t,
				size: t.length || 0,
				max: n,
				words_size_ar: r
			}
		},
		preSum: function(e) {
			if (!e || !e.length) return e;
			var t = new Array(e.length);
			t[0] = e[0];
			for (var r = 1; r < e.length; ++r) t[r] = e[r] + t[r - 1];
			return t
		},
		postSum: function(e) {
			if (!e || !e.length) return e;
			var t = new Array(e.length);
			t[e.length - 1] = e[e.length - 1];
			for (var r = e.length - 2; 0 <= r; --r) t[r] = e[r] + t[r + 1];
			return t
		},
		trunc: function(e) {
			return isNaN(e) ? NaN : 0 < e ? Math.floor(e) : Math.ceil(e)
		},
		isEmpty: function(e) {
			return null == e || (Array.isArray(e) ? !e.length : !Object.keys(e).length)
		},
		makeObjectAbsolute: function(e) {
			if (e) {
				for (var t = Object.keys(e), r = 0; r < t.length; ++r) "object" === _typeof(e[t[r]]) ? c.makeObjectAbsolute(e[t[r]]) : e[t[r]] = Math.abs(e[t[r]]);
				return e
			}
		},
		isValidEmail: function(e) {
			if (e) return -1 !== (e = Array.isArray(e) ? e[0] : e).toString().search(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)
		},
		isAllKeysTrue: function(e, t, r) {
			if ("object" === _typeof(e)) {
				for (var n = Object.keys(e), i = 0; i < n.length; ++i)
					if (e[n[i]] !== r) return !1
			} else
				for (var a = 0; a < e.length; ++a)
					if (t && e[a][t] !== r) return !1;
			return !0
		}
	};
	return c
}();